import { Pipe, PipeTransform } from '@angular/core';
import { Member } from '../models/member/member.model';

export type DefMemberNamePipeFormat = 'firstName' | 'fullName' | 'lastName';

@Pipe({
  name: 'defMemberName',
})
export class DefMemberNamePipe implements PipeTransform {

  /**
   * Returns member full name
   *
   * @param member Member whose name we want
   */
  private static getFullName(member: Member): string {
    return member.getFullName();
  }

  /**
   * Returns the first name of a member
   *
   * @param member Member whose name we want
   */
  private static getFirstName(member: Member): string {
    return member['firstName'] ?? member['given_name'][0];
  }

  /**
   * Returns the last name of a member
   *
   * @param member Member whose name we want
   */
  private static getLastName(member: Member): string {
    return member['lastName'] ?? member['sn'][0];
  }

  public transform(value: Member, format: DefMemberNamePipeFormat = 'fullName'): any {
    if (!value) {
      return '';
    }

    switch (format) {
      case 'firstName':
        return DefMemberNamePipe.getFirstName(value);
      case 'lastName':
        return DefMemberNamePipe.getLastName(value);
      case 'fullName':
      default:
        return DefMemberNamePipe.getFullName(value);
    }
  }
}
